import React, { useEffect } from 'react';

function FormRow(props) {


    useEffect(() => {

    }, []);


    return (
        <div className=" formgroup-inline col-12 md:col-12" style={{ textAlign: "left" }}>
            <div className='col-4'>
                {props.left}
            </div>
            <div className='col-8'>
                {props.right}
            </div>
        </div>
    )
}

export default FormRow
